import React, { useEffect, useState } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import WalletCard from "../../components/RetailerBusinessAgent/WallertCard";
import WelcomeModal from "../../components/RetailerBusinessAgent/WelcomeModal";
import { API_URL } from "../../constant";
import wallet2 from "../../images/shapes/Wallet03.1 1.png";
import wallet1 from "../../images/shapes/Wallet01 5.png";
import dollarY from "../../images/shapes/Dollar Bag (1).png";
import dollarG from "../../images/shapes/Dollar Bag.png";
import gift from "../../images/shapes/Gift.png";
import oldbank from "../../images/shapes/bank-pound-icon2 4.png";
import history1 from "../../images/shapes/Group 37483.png";
import MiniAgentForm from "../../components/MiniAgent/MiniAgentForm";

const CustomerWallet = () => {
  const navigate = useNavigate();
  const { userData, showAgentFormModal, setShowAgentFormModal } = useOutletContext();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [walletData, setWalletData] = useState(null);
  const [agentWalletData, setAgentWalletData] = useState(null);
  const [networkTopCoinData, setNetworkTopCoinData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [hasExistingApplication, setHasExistingApplication] = useState(false);
  const [applicationStatus, setApplicationStatus] = useState(null);
  const [isMiniAgent, setIsMiniAgent] = useState(false);
  const [agentApplicationLoading, setAgentApplicationLoading] = useState(true);
  const [containerStyle, setContainerStyle] = useState({});

  // Check if user is an advertising agent
  const isAdvertisingAgent =
    userData?.role?.includes("Advertising Agent") ||
    userData?.isAdvertisingAgent ||
    userData?.role === "mini" ||
    userData?.role === "senior";

  useEffect(() => {
    if (!userData) {
      navigate("/sign_in");
      return;
    }

    // Set background based on role
    setContainerStyle(getContainerStyle(userData?.role));

    fetchWalletData();
    checkMiniAgentStatus();
  }, [userData, navigate]);

  const getContainerStyle = (role) => {
    let background = "";

    switch (role) {
      case "Senior Customer Advertising Agent":
        background = "linear-gradient(to bottom, #0d6efd, white)";
        break;
      case "Mini Customer Advertising Agent":
        background = "linear-gradient(to bottom, #0000a0, white)";
        break;
      case "Customer":
      default:
        background = "linear-gradient(to bottom, #6f42c1, white)";
        break;
    }

    return {
      display: "flex",
      flexDirection: "column",
      marginTop: "0px",
      marginBottom: "0px",
      background: background,
      width: "100%",
      minHeight: "130vh",
      fontFamily: "'Poppins', sans-serif",
      padding: "20px",
    };
  };

  // Check if modal has been shown before for this user
  const hasModalBeenShown = () => {
    const userId = userData?.id || userData?.email;
    if (!userId) return false;

    const shownModals = JSON.parse(
      localStorage.getItem("shown_welcome_modals") || "{}"
    );
    return shownModals[userId] === true;
  };

  // Mark modal as shown for this user
  const markModalAsShown = () => {
    const userId = userData?.id || userData?.email;
    if (!userId) return;

    const shownModals = JSON.parse(
      localStorage.getItem("shown_welcome_modals") || "{}"
    );
    shownModals[userId] = true;
    localStorage.setItem("shown_welcome_modals", JSON.stringify(shownModals));
  };

  // Check mini agent status
  const checkMiniAgentStatus = async () => {
    try {
      const token = localStorage.getItem("auth_token");
      if (!token) return;

      const response = await fetch(
        `${API_URL}/api/advertising-agents/application`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.application) {
          setHasExistingApplication(true);
          setApplicationStatus(data.application.status);

          if (data.application.status === "approved") {
            setIsMiniAgent(true);
          }
        }
      }
    } catch (error) {
      console.error("Error checking mini agent status:", error);
    } finally {
      setAgentApplicationLoading(false);
    }
  };

  const fetchWalletData = async () => {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      navigate("/sign_in");
      return;
    }

    setIsLoading(true);
    try {
      const walletResponse = await fetch(`${API_URL}/api/customer/wallet`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!walletResponse.ok) throw new Error("Failed to fetch wallet data");
      const walletData = await walletResponse.json();

      console.log("Wallet API Response:", walletData);

      // Check if user is an advertising agent and fetch agent data
      if (isAdvertisingAgent) {
        let agentWalletPoints = 0;
        let networkTopCoin = 0;

        if (walletData.agent_wallet_points !== undefined) {
          agentWalletPoints = walletData.agent_wallet_points;
        } else if (walletData.agent_wallet?.points !== undefined) {
          agentWalletPoints = walletData.agent_wallet.points;
        } else if (walletData.data?.agent_wallet_points !== undefined) {
          agentWalletPoints = walletData.data.agent_wallet_points;
        } else if (
          walletData.wallet_details?.agent_wallet?.points !== undefined
        ) {
          agentWalletPoints = walletData.wallet_details.agent_wallet.points;
        }

        console.log("Extracted agent wallet points:", agentWalletPoints);

        setAgentWalletData({
          points: agentWalletPoints,
        });

        // Try to get network topcoin from different possible structures
        if (walletData.network_topcoin !== undefined) {
          networkTopCoin = walletData.network_topcoin;
        } else if (walletData.network_wallet?.points !== undefined) {
          networkTopCoin = walletData.network_wallet.points;
        } else if (walletData.data?.network_topcoin !== undefined) {
          networkTopCoin = walletData.data.network_topcoin;
        }

        setNetworkTopCoinData({
          points: networkTopCoin,
        });
      }

      // Set wallet data
      setWalletData({
        points: walletData.units || walletData.wallet?.units || 0,
        cashBalance: walletData.cash_balance || 0,
        transactions: walletData.transactions || [],
      });

      // Check if modal should be shown for this user
      const userId = userData?.id || userData?.email;
      if (userId && !hasModalBeenShown()) {
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error fetching wallet data:", error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    markModalAsShown();
  };

  const handleAgentRequest = () => {
    if (setShowAgentFormModal) {
      setShowAgentFormModal(true);
    }
  };

  const handleMiniAgentSubmit = (responseData) => {
    console.log("Mini-Agent Form submitted successfully:", responseData);
    if (setShowAgentFormModal) {
      setShowAgentFormModal(false);
    }
    // Refresh the application status
    checkMiniAgentStatus();
  };

  const handleAgentFormClose = () => {
    if (setShowAgentFormModal) {
      setShowAgentFormModal(false);
    }
  };

  if (isLoading) {
    return (
      <div
        style={{
          ...containerStyle,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div style={{ marginTop: "20px" }}>
          <div
            style={{
              width: "40px",
              height: "40px",
              border: "4px solid #f3f3f3",
              borderTop: "4px solid #3498db",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          ></div>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          ...containerStyle,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div style={{ color: "red" }}>Error: {error}</div>
      </div>
    );
  }

  if (!walletData) {
    return null;
  }

  // Calculate total earnings
  const totalEarnings = (
    walletData.points * 0.005 +
    walletData.cashBalance +
    (agentWalletData?.points || 0) * 0.005
  ).toFixed(2);

  // Prepare user data for modal
  const modalUserData = {
    firstName: userData?.firstName || "Customer",
    sureName: userData?.lastName || "",
    fullName:
      `${userData?.firstName || ""} ${userData?.sureName || ""}`.trim() ||
      "Customer",
    role: userData?.role || "Customer",
    avatar: userData?.photo_url || "",
    email: userData?.email || "",
    phone: userData?.phone || "",
    id: userData?.id || userData?.email || "",
  };

  // Determine agent wallet card content based on status
  const getAgentWalletContent = () => {
    if (isAdvertisingAgent && agentWalletData) {
      return {
        title: `${
          userData?.role === "mini"
            ? "Mini"
            : userData?.role === "senior"
            ? "Senior"
            : "Agent"
        } Wallet`,
        amount: `${agentWalletData.points || 0} (£ ${(
          (agentWalletData.points || 0) * 0.005
        ).toFixed(2)})`,
        subText: "Agent Earnings",
        bgColor: "#eff6ff",
        bgColor1: "#dbeafe",
        onClick: () => navigate(""),
        buttonText: "History",
        showButton: false,
        icon: gift,
      };
    } else if (hasExistingApplication) {
      if (applicationStatus === "pending") {
        return {
          title: "Mini Advertising Agent",
          amount: "Pending",
          subText: "Application under review",
          bgColor: "#fef3c7",
          bgColor1: "#fef3c7",
          onClick: null,
          buttonText: "Progress...",
          showButton: true,
          disabled: true,
          icon: gift,
        };
      } else if (applicationStatus === "rejected") {
        return {
          title: "Mini Advertising Agent",
          amount: "Rejected",
          subText: "Contact support",
          bgColor: "#fee2e2",
          bgColor1: "#fee2e2",
          onClick: handleAgentRequest,
          buttonText: "Try Again >",
          showButton: true,
          icon: gift,
        };
      }
    } else {
      return {
        title: "Become Mini Advertising Agent",
        amount: "Earn More",
        subText: "Become an Agent",
        bgColor: "#ecfdf5",
        bgColor1: "#d1fae5",
        onClick: handleAgentRequest,
        buttonText: "Request >",
        showButton: true,
        icon: gift,
      };
    }
  };

  const agentWalletContent = getAgentWalletContent();

  return (
    <div style={{ ...containerStyle, height: "auto" }}>
      <div className="wallet-container1">
        {/* Earned TopCoin (Own) */}
        <WalletCard
          imgH={wallet2}
          imgT={dollarG}
          imgHi={history1}
          title="Earned TopCoin Wallet (Own)"
          amount={`0`}
          subText="Available TopCoin"
          bgColor="#f0fdf4"
          historyLink=""
          bgColor1="#dcfce7"
          onHistoryClick={() => navigate("")}
        />

        {/* Bonus TopCoin (Own) */}
        <WalletCard
          imgH={wallet2}
          imgT={dollarG}
          imgHi={history1}
          title="Bonus TopCoin Wallet (Own)"
          amount={`${walletData.points}`}
          subText="Available TopCoin"
          bgColor="#f0fdf4"
          historyLink=""
          bgColor1="#dcfce7"
          onHistoryClick={() => navigate("")}
        />

        {/* Earned Bonus (Own) */}
        <WalletCard
          imgH={wallet1}
          imgT={dollarY}
          imgHi={history1}
          title="Earned Bonus Wallet (Own)"
          amount={`£ 0`}
          subText="Available Cash"
          bgColor="#fff7ed"
          bgColor1="#ffedd5"
          historyLink=""
          onHistoryClick={() => navigate("")}
        />

        {/* Given Bonus (Own) */}
        <WalletCard
          imgH={wallet1}
          imgT={dollarY}
          imgHi={history1}
          title="Given Bonus Wallet (Own)"
          amount={`£ ${0}`}
          subText="Available Cash"
          bgColor="#fff7ed"
          bgColor1="#ffedd5"
          historyLink=""
          onHistoryClick={() => navigate("")}
        />

        {/* Cash (Own) */}
        <WalletCard
          imgH={wallet1}
          imgT={dollarY}
          imgHi={history1}
          title="Reward Wallet (Own)"
          amount={`£ 0`}
          subText="Available Cash"
          bgColor="#fff7ed"
          bgColor1="#ffedd5"
          historyLink=""
          onHistoryClick={() => navigate("")}
        />

        {/* TopCoin (Network) - Only show for advertising agents */}
        {/* {isAdvertisingAgent ? (
          <WalletCard
            imgH={wallet2}
            imgT={dollarG}
            imgHi={history1}
            title="TopCoin Wallet (Network)"
            amount={`${networkTopCoinData?.points || 0}`}
            subText="Available TopCoin"
            bgColor="#f0fdf4"
            historyLink=""
            bgColor1="#dcfce7"
            onHistoryClick={() => navigate("")}
          />
        ) : (
          <div></div>
        )} */}

        {/* Agent Wallet Card - Show only for advertising agents or with application status */}
        {/* Commented out as per your previous code */}
        {/* <WalletCard
          imgH={wallet1}
          imgHi={
            agentWalletContent.showButton
              ? agentWalletContent.disabled
                ? null
                : ""
              : history1
          }
          imgT={agentWalletContent.icon || gift}
          title={agentWalletContent.title}
          amount={agentWalletContent.amount}
          subText={agentWalletContent.subText}
          bgColor={agentWalletContent.bgColor}
          bgColor1={agentWalletContent.bgColor1}
          onHistoryClick={agentWalletContent.onClick}
          buttonText={agentWalletContent.buttonText}
          disabled={agentWalletContent.disabled}
        /> */}

        {/* Total Earnings - Commented out as per your previous code */}
        {/* <WalletCard
          imgH={wallet1}
          imgHi={history1}
          imgT={dollarY}
          title="Total Earnings"
          amount={`£ ${totalEarnings}`}
          subText="All Wallets Combined"
          bgColor="#fffbeb"
          bgColor1="#fef3c7"
        /> */}

      {/* Withdraw Card - Disabled/Grayed out */}
        <WalletCard
          imgH={oldbank}
          imgT={dollarY}
          title="Withdraw"
          amount={`£ ${(0).toFixed(2)}`}
          subText="Available Cash"
          bgColor="#f5f5f5"
          bgColor1='#e0e0e0'
          historyLink="#"
          buttonText="Withdraw"
          disabled={true}
          showButton={true}
        />
        
      </div>

      {/* Welcome Modal */}
      {showModal && (
        <WelcomeModal user={modalUserData} onClose={handleCloseModal} />
      )}

      {/* Mini Agent Form Modal - Now controlled from context */}
      {(showAgentFormModal || false) && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={handleAgentFormClose}
        >
          <div
            className="modal-box"
            style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "30px",
              maxWidth: "800px",
              width: "90%",
              maxHeight: "90vh",
              overflowY: "auto",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="close-modal-btn"
              onClick={handleAgentFormClose}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                background: "none",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                color: "#666",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                transition: "background-color 0.3s",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
              onMouseLeave={(e) =>
                (e.target.style.backgroundColor = "transparent")
              }
            >
              &times;
            </button>

            <MiniAgentForm
              onSubmit={handleMiniAgentSubmit}
              onClose={handleAgentFormClose}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerWallet;